var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.external ? 'a' : 'nuxt-link',{tag:"component",staticClass:"p-breadcrumb-item",class:{
    'p-breadcrumb-item--external': _vm.external,
    'p-breadcrumb-item--active': _vm.active,
  },attrs:{"exact-path":"","to":!_vm.external ? _vm.to : undefined,"href":_vm.external ? _vm.to : undefined}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }